import {useNavigate} from "react-router-dom";
import {Container} from "@yosmanyga/rich-ui";
import {BlankLayout} from "../BlankLayout.tsx";
import {PaymentSuccess} from '../view';

const PaymentSuccessScreen = () => {
    const navigate = useNavigate();

    return <PaymentSuccess
        templates={{
            layout: ({children}) => {
                return <BlankLayout>
                    <Container
                        flow='column'
                        align={{
                            cross: 'center'
                        }}
                    >
                        {children}
                    </Container>
                </BlankLayout>
            }
        }}
        onContinue={() => {
            navigate('/');
        }}
    />
};

export {PaymentSuccessScreen};
